/* eslint-disable no-unused-vars */
import { FETCH_OVERVIEW_ORDER_SUMMARY } from './orderSummaryTypes';

const orderOverviewSummaryInitial = {
    total: 10,
    'wc-completed': 2,
    'wc-pending': 2,
    'wc-processing': 0,
    'wc-cancelled': 1,
    'wc-refunded': 1,
    'wc-on-hold': 2,
    'wc-failed': 2,
};

const OrderOverViewSummary = (state = orderOverviewSummaryInitial, { type, payload }) => {
    switch (type) {
        case FETCH_OVERVIEW_ORDER_SUMMARY:
            return state;
        default:
            return state;
    }
};

export default OrderOverViewSummary;
